var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Message',{attrs:{"severity":_vm.severity,"closable":_vm.closable,"sticky":_vm.sticky,"life":_vm.life},on:{"close":function($event){return _vm.$emit('close', $event)}}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }